export const STORAGE_KEY_GOOGLE_ADS_PARAMETERS = 'GlobalE_Analytics_GoogleAds';

export const GCLID = 'gclid';
export const BFGCLID = 'bfgclid';

export type GoogleAdsHandlerSettings = {
  bfGoogleAdsEnabled: boolean;
  bfGoogleAdsLifetimeInDays: number;
}

export type GoogleAdsPreset = string | GoogleAds;

export type GoogleAds = {
  gclid: string;
  bfgclid: string;
};